import React from "react";
import PropTypes from 'prop-types';
import Tabs from 'react-responsive-tabs';

import WithLoading from './WithLoading';
import { 
  BuildProjectGalleryRequest,
  BuildVideoGalleryRequest,
  BuildDocumentWarrantiesRequest,
  FetchMediaObjects,
  BlogList,
  ProjectGallery,
  VideoGallery,
  DocumentList
} from '../media';

import 'react-responsive-tabs/styles.css';

class ProductDetailTabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      galleryMedia: {
        totalCount: 0,
        mediaObjects: [],
        isLoading: true
      },
      videoMedia: {
        totalCount: 0,
        mediaObjects: [],
        isLoading: true
      },
      documentMedia: {
        totalCount: 0,
        mediaObjects: [],
        isLoading: true
      }
    };

    this.updateMedia = this.updateMedia.bind(this);
  }

  componentDidMount() {
    const { gallery, videos, documentWarranties } = this.props;
    this._projectMediaRequest = this.updateMedia(gallery).then(_ => this._projectMediaRequest = null);
    this._videoMediaRequest = this.updateMedia(videos).then(_ => this._videoMediaRequest = null);
    this._documentMediaRequest = this.updateMedia(documentWarranties).then(_ => this._documentMediaRequest = null);
  }

  componentWillUnmount() {
    if (this._projectMediaRequest) {
      this._projectMediaRequest.cancel();
    }
    if (this._videoMediaRequest) {
      this._videoMediaRequest.cancel();
    }
    if (this._documentMediaRequest) {
      this._documentMediaRequest.cancel();
    }
  }

  getSpecificationsContent(currentVariation, showProductInfo) {
    let attributes = currentVariation.VariationAttributes,
        oddAttributes = [],
        evenAttributes = [];
  
    // Split Attributes between odds and evens for desktop view
    for (var i = 0; i < attributes.length; i++) {
      const attribute = attributes[i];

      if (i % 2 < 1) {
        oddAttributes.push(attribute);
      } else {
        evenAttributes.push(attribute);
      }
    }

    const productDetails = showProductInfo
      ? (
        <React.Fragment>
          <p><b>Item Number:</b> {currentVariation.BRPART}</p>
          <div dangerouslySetInnerHTML={{ __html: currentVariation.Description }} />
        </React.Fragment>
      )
      : null;
  
    return (
      <div className='variation-details' id="variation-details">
        {productDetails}
        <div id="technicalSpecifications" className='product-details-attributes'>
          <div className='row'>
            <div className='col-xs-12 visible-xs visible-sm'>
              <table className='table table-striped table-bordered table-hover table-condensed'>
                <tbody>
                  {attributes.map(attr => (
                    <tr key={`${attr.AttributeName}_${attr.AttributeValueCode}`} className='product-attributes-row'>
                      <td className='product-attributes-label'>
                        <label>{`${attr.AttributeName}: `}</label>
                      </td>
                      <td className='product-attributes-data'>
                        {`${attr.AttributeValueName}`}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className='col-xs-12 col-md-6 hidden-xs hidden-sm'>
              <table className='table table-striped table-bordered table-hover table-condensed'>
                <tbody>
                  {oddAttributes.map((attr) => (
                    <tr key={`${attr.AttributeName}_${attr.AttributeValueCode}`} className='product-attributes-row'>
                      <td className='product-attributes-label'>
                        <label>{`${attr.AttributeName}: `} </label>
                      </td>
                      <td className='product-attributes-data'>
                        {`${attr.AttributeValueName}`}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className='col-xs-12 col-md-6 hidden-xs hidden-sm'>
              <table className='table table-striped table-bordered table-hover table-condensed'>
                <tbody>
                  {evenAttributes.map((attr) => (
                    <tr key={`${attr.AttributeName}_${attr.AttributeValueCode}`} className='product-attributes-row'>
                      <td className='product-attributes-label'>
                        <label>{`${attr.AttributeName}: `}</label>
                      </td>
                      <td className='product-attributes-data'>
                        {`${attr.AttributeValueName}`}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  async updateMedia(requestParams) {
    let requestOptions, propertyName;

    if (typeof requestParams === 'undefined') 
      return;

    switch (requestParams.Format.toUpperCase()) {
      case "JPG,PNG":
        requestOptions = BuildProjectGalleryRequest(requestParams);
        propertyName = 'galleryMedia';
        break;
      case "YOUTUBE":
        requestOptions = BuildVideoGalleryRequest(requestParams);
        propertyName = 'videoMedia';
        break;
      case "PDF":
        requestOptions = BuildDocumentWarrantiesRequest(requestParams);
        propertyName = 'documentMedia';
        break;
      default:
        // Not Implemented
        return;
    }
    
    const mediaObjectsResult = await FetchMediaObjects(requestOptions);
    const mediaObjectData = typeof mediaObjectsResult.metadata !== 'undefined'
      ? mediaObjectsResult.metadata.mediaObjects
      : mediaObjectsResult.mediaObjects;
    let mediaObjects = mediaObjectData.mediaObject;

    if (typeof mediaObjects === 'object' && !Array.isArray(mediaObjects)) {
      mediaObjects = [ mediaObjects ];
    }

    this.setState({
      [propertyName]: {
        totalCount: mediaObjectData["@totalCount"],
        mediaObjects: mediaObjects,
        isLoading: false
      }
    });
  }

  render() {
    const {
      currentVariation,
      gallery,
      videos,
      blogs,
      documentWarranties,
      resources,
      showProductInfo
    } = this.props;

    const { galleryMedia, videoMedia, documentMedia } = this.state;
    const showSpecifications = currentVariation.VariationAttributes.length > 0 || showProductInfo,
          showGallery = typeof gallery !== 'undefined' && gallery.ShowGallery && typeof galleryMedia !== 'undefined' && galleryMedia.totalCount > 0,
          showVideos = typeof videos !== 'undefined' && videos.ShowGallery && typeof videoMedia !== 'undefined' && videoMedia.totalCount > 0,
          showBlogs = typeof blogs !== 'undefined' && blogs.BlogRecords !== null && blogs.BlogRecords.length > 0,
          showDocuments = typeof documentWarranties !== 'undefined' && documentWarranties.ShowGallery && typeof documentMedia !== 'undefined' && documentMedia.totalCount > 0,
          showResources = typeof resources !== 'undefined' && resources.length > 0,
          tabs = [];

    if (showSpecifications) {
      tabs.push({ title: "Specifications", key: 1, getContent: () => this.getSpecificationsContent(currentVariation, showProductInfo) });
    }

    if (showGallery) {
      tabs.push({ title: "Gallery", key: 2, getContent: () => WithLoading(<ProjectGallery mediaObjects={galleryMedia.mediaObjects} totalCount={galleryMedia.totalCount} isLoading={galleryMedia.isLoading} />) });
    }

    if (showVideos) {
      tabs.push({ title: "Videos", key: 3, getContent: () => WithLoading(<VideoGallery mediaObjects={videoMedia.mediaObjects} totalCount={videoMedia.totalCount} isLoading={videoMedia.isLoading} />) });
    }
  
    if (showBlogs) {
      tabs.push({ title: "Related Blogs", key: 4, getContent: () => <BlogList blogEntries={blogs.BlogRecords} /> });
    }

    if (showDocuments) {
      tabs.push({ title: "Documents & Warranties", key: 5, getContent: () => WithLoading(<DocumentList mediaObjects={documentMedia.mediaObjects} totalCount={documentMedia.totalCount} isLoading={documentMedia.isLoading} />) });
    }

    if (showResources) {
      const resourceMedia = resources.map((resource, index) => ({ url: resource.Url, title: resource.Name, code: index }));
      tabs.push({ title: "Resources", key: 6, getContent: () => <DocumentList mediaObjects={resourceMedia} totalCount={resources.totalCount} /> });
    }
    
    return (
      <Tabs items={tabs} transformWidth={500} />
    );
  }
}

ProductDetailTabs.propTypes = {
  assets: PropTypes.array,
  blogs: PropTypes.object,
  currentVariation: PropTypes.object,
  gallery: PropTypes.object,
  resources: PropTypes.array,
  videos: PropTypes.object
};

export default ProductDetailTabs;